import { useState, useEffect } from "react";
import TermSection from "../components/TermSection";
import { extractItem } from "../utils";
import GameEnd from "./GameEnd";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { X, Check, ArrowLeft } from "react-feather";
import settings from "../data/settings";
import Tippy from "@tippyjs/react";
import timeLimits from "../data/timeLimits";
import categories from "../data/categories";
import ls from "local-storage";

function GamePage({
  terms,
  timeLimit,
  category,
  difficulty,
  setInGame,
  highScore,
  setHighScore,
}) {
  const deepCopyTerms = JSON.parse(JSON.stringify(terms));
  const [history, setHistory] = useState([
    extractItem(deepCopyTerms),
    extractItem(deepCopyTerms),
    extractItem(deepCopyTerms),
  ]);
  //console.log(deepCopyTerms.length);
  const [clonedTerms, setClonedTerms] = useState(deepCopyTerms);
  const [hasLost, setHasLost] = useState(false);
  const [showValue, setShowValue] = useState(false);
  const [goToNextSection, setGoToNextSection] = useState(false);
  const [score, setScore] = useState(
    categories.reduce((obj, item) => {
      return { ...obj, [item.label]: 0 };
    }, {})
  );
  const [isCorrect, setIsCorrect] = useState();
  const currentScore = score[category.label];
  useEffect(() => {
    if (currentScore > highScore[category.label]) {
      const newHighScore = { ...highScore };
      newHighScore[category.label] = currentScore;
      setHighScore(newHighScore);
      ls.set(category.label, newHighScore[category.label]);
    }
  }, [currentScore, category.label, highScore, score, setHighScore]);

  if (!terms) return <div>No terms 🤷‍♂️</div>;

  function handleClick(action) {
    let isCorrect =
      action === "higher"
        ? curTerm.value >= prevTerm.value
        : curTerm.value <= prevTerm.value;
    if (Math.abs(curTerm.value - prevTerm.value) <= settings.marginOfError)
      isCorrect = true;
    setIsCorrect(isCorrect);
    setShowValue(true);
    if (isCorrect) {
      const newScore = { ...score };
      //console.log(category.label);
      newScore[category.label] +=
        (100 + timeLimit.scoreBonus) * difficulty.scoreMultiplier;
      setScore(newScore);
    }
    setTimeout(() => {
      if (!isCorrect) setHasLost(true);
      setShowValue(false);
      setGoToNextSection(true);
      setIsCorrect(undefined);
      setTimeout(() => {
        setHistory((prevHistory) => prevHistory.concat(extractClonedTerm()));
        setGoToNextSection(false);
      }, 1000);
    }, 2000);
  }

  const extractClonedTerm = () => {
    const array = [...clonedTerms];
    const extractedItem = extractItem(array);
    //console.log(terms.length, array.length, extractedItem);
    setClonedTerms(
      array.length === 0 ? JSON.parse(JSON.stringify(terms)) : array
    );
    return extractedItem;
  };

  const prevTerm = history[history.length - 3];
  const curTerm = history[history.length - 2];
  //console.log(curTerm.value >= prevTerm.value ? "higher" : "lower");

  return (
    <>
      {hasLost ? (
        <GameEnd
          timeLimit={timeLimit}
          category={category}
          difficulty={difficulty}
          score={score}
          setInGame={setInGame}
          onPlayAgain={() => {
            setHasLost(false);
            setScore(
              categories.reduce((obj, item) => {
                return { ...obj, [item.label]: 0 };
              }, {})
            );
          }}
        />
      ) : (
        <>
          <div
            className={`${
              goToNextSection
                ? "duration-1000 transition-transform transform -translate-y-1/3 lg:-translate-x-1/3 lg:translate-y-0"
                : ""
            } flex flex-col lg:flex-row lg:w-3/2 h-3/2 overflow-hidden lg:h-full`}
          >
            <TermSection
              onClick={handleClick}
              history={history}
              position={1}
              category={category}
            />
            <TermSection
              onClick={handleClick}
              history={history}
              showValue={showValue || goToNextSection}
              goToNextSection={goToNextSection}
              position={2}
            />
            <TermSection
              onClick={handleClick}
              history={history}
              goToNextSection={goToNextSection}
              position={3}
            />
          </div>

          <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center w-10 h-10 "></div>

          {!goToNextSection && (
            <div
              className={`transform duration-300 absolute top-0 bottom-0 left-0 right-0 m-auto flex items-center justify-center w-10 h-10 rounded-full ${
                isCorrect === undefined
                  ? "text-black bg-white"
                  : isCorrect
                  ? "scale-125 bg-blue-400"
                  : "scale-125 bg-red-400"
              }`}
            >
              {isCorrect === undefined ? (
                <>
                  {timeLimit?.value !== null ? (
                    <CountdownCircleTimer
                      size={60}
                      strokeWidth={5}
                      trailColor="transparent"
                      isPlaying
                      duration={timeLimit.value}
                      colors={[
                        ["#6D28D9", 0.16],
                        ["#93C5FD", 0.16],
                        ["#1D4ED8", 0.16],
                        ["#8B5CF6", 0.16],
                        ["#FCD34D", 0.16],
                        ["#F87171", 0.16],
                      ]}
                      onComplete={() =>
                        handleClick(
                          curTerm.value >= prevTerm.value ? "lower" : "higher"
                        )
                      }
                    >
                      {({ remainingTime }) => (
                        <div className="text-xl font-semibold uppercase">
                          {remainingTime}
                        </div>
                      )}
                    </CountdownCircleTimer>
                  ) : (
                    <div className="p-4 text-xl font-semibold uppercase">
                      vs
                    </div>
                  )}
                </>
              ) : isCorrect ? (
                <Check />
              ) : (
                <X />
              )}
            </div>
          )}
          <div className="absolute top-0 flex justify-between w-full px-4 py-4">
            <ArrowLeft
              className="cursor-pointer"
              onClick={() => setInGame(false)}
            />
            <div className="flex">
              <Tippy content={category.label}>
                <h1>{category.emoji}</h1>
              </Tippy>
              {" / "}
              <Tippy content={difficulty.label}>
                <h1>{difficulty.emoji}</h1>
              </Tippy>
              {" / "}
              <Tippy content={timeLimits.label}>
                <h1>⌛ {timeLimit.label}</h1>
              </Tippy>
            </div>
          </div>
          <div className="absolute bottom-0 flex justify-between w-full px-4 py-4 text-xl font-bold">
            <h1>High Score: {highScore[category.label]}</h1>
            <h1
              className={`transform duration-300 ${
                isCorrect ? "scale-125 pr-2" : "scale-100"
              }`}
            >
              Score: {score[category.label]}
            </h1>
          </div>
        </>
      )}
    </>
  );
}
//
export default GamePage;
